import { Service } from "./Service";
import { CountryBasedSubscriptionService } from "./CountryBasedSubscriptionService";
import { HourlyService } from "./HourlyService";
import { OssSubscriptionService } from "./OssSubscriptionService";
import { SimpleService } from "./SimpleService";
import { SubscriptionService } from "./SubscriptionService";
export class ServiceFactory {
  static create($type) {
    if ($type === "V1.Orders.Services.Service") {
      const result = new Service();
      return result;
    }
    if ($type === "V1.Orders.Services.CountryBasedSubscriptionService") {
      const result = new CountryBasedSubscriptionService();
      return result;
    }
    if ($type === "V1.Orders.Services.HourlyService") {
      const result = new HourlyService();
      return result;
    }
    if ($type === "V1.Orders.Services.OssSubscriptionService") {
      const result = new OssSubscriptionService();
      return result;
    }
    if ($type === "V1.Orders.Services.SimpleService") {
      const result = new SimpleService();
      return result;
    }
    if ($type === "V1.Orders.Services.SubscriptionService") {
      const result = new SubscriptionService();
      return result;
    }
    throw new Error($type + " not found");
  }
}
